// this maps the "view" query param values that can come in
// the external_login url to specific ember routes, so that
// we can redirect the users after logging them successfully

module.exports = ({
    'vat-rates-settings': 'vat_rates_settings'
})
